import React, { useEffect, useState } from 'react'
import {
    Box,
    Text,
    Button,
    Link,
    HStack,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { FormattedMessage } from 'react-intl'

/* Hooks */
import { useStoreLocator } from '../../../contexts/store-locator-context';

/* Icons */
import { ChevronRightIcon, CustomClose } from '../../../components/icons'

/* Configs */
import { STORE_LOCATOR_CONFIGS } from '../configs'

const StoreLocatorInfo = ({
    variant,
    onStoreInfoClick,
    availabilityText,
    availabilityColor
}) => {
    /* Styling */
    const styles = useMultiStyleConfig('StoreInfo', {
        variant
    })
    const [hoursStatus, setHoursStatus] = useState(null)
    const {
        selectedStore,
        toggleStoreInfo,
        setToggleStoreInfo,
        getLocalizedHoursStatus,
        onOpenStoreDetails
    } = useStoreLocator()

    useEffect(() => {
        if (selectedStore && variant !== 'FindInStore') {
            setHoursStatus(getLocalizedHoursStatus(selectedStore))
        }
    }, [selectedStore])

    const handleStoreInfoClick = () => {
        if (variant !== 'FindInStore') {
            onOpenStoreDetails()
        }

        onStoreInfoClick(selectedStore)
    }

    return (
        <>
            {toggleStoreInfo &&
                <Box {...styles.container}
                    onClick={handleStoreInfoClick}
                    onKeyDown={(e) => e.key === 'Enter' && handleStoreInfoClick?.(e)}
                    role="button"
                    tabIndex={0}
                    aria-label={`Info about store ${selectedStore?.name}`}>
                    <Box {...styles.content}>
                        {variant === 'FindInStore' &&
                            <IconButton
                                variant="unstyled"
                                h={'auto'}
                                minW={'auto'}
                                {...styles.customClose}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    setToggleStoreInfo(false)
                                }}
                                icon={<Icon as={CustomClose} />}
                                aria-label="Close drawer menu"
                            />
                        }
                        <Box {...styles.info}>
                            <Text {...styles.name}>
                                {selectedStore?.name}
                            </Text>
                            <Text {...styles.address}>
                                {selectedStore?.address1}
                            </Text>
                            <Text {...styles.address}>
                                {selectedStore?.city}, {selectedStore?.postalCode}
                            </Text>
                        </Box>
                        <ChevronRightIcon />
                    </Box>
                    {variant !== 'FindInStore' &&
                        <Text {...styles.hours} {...styles.hours}>
                            {hoursStatus?.status === 'OPEN_UNTIL' ? (
                                <Box as='span' {...styles.greenDot}></Box>
                            ) : (
                                <Box as='span' {...styles.redDot}></Box>
                            )}
                            {hoursStatus?.message}
                        </Text>
                    }
                    {variant === 'FindInStore' &&
                        <HStack>
                            <Box w="6px" h="6px" bg={availabilityColor} />
                            <Text fontSize="xs">{availabilityText}</Text>
                        </HStack>
                    }
                    <Box  {...styles.ctas}>
                        {selectedStore?.phone &&
                            <Button as={Link} variant="outline" {...styles.cta}
                                href={`tel:${selectedStore?.phone}`}>
                                <FormattedMessage
                                    defaultMessage="Call Store"
                                    id="store_locator.call_store"
                                />
                            </Button>
                        }
                        <Button as={Link} {...styles.cta}
                            href={STORE_LOCATOR_CONFIGS.getDirectionURL + selectedStore?.latitude + ',' + selectedStore?.longitude}
                            target="_blank"
                            rel="noopener noreferrer">
                            <FormattedMessage
                                defaultMessage="Get Directions"
                                id="store_locator.get-directions"
                            />
                        </Button>
                    </Box>
                </Box>
            }
        </>
    )
}

export default StoreLocatorInfo
